// extracted by mini-css-extract-plugin
export var resizer = "_hq-0";